import * as Yup from 'yup';
import { PROJECT_TYPES } from '../../constants';

export const editProjectNameFormYupValidation = (projectType) => {
  return Yup.object().shape({
    projectName: Yup.string().required('required'),

    ...(projectType === PROJECT_TYPES.GENIE_GO
      ? {
          description: Yup.string().required('required'),
          referenceMessages: Yup.string().required('required'),
          brand: Yup.string().required('required'),
        }
      : {}),

    ...(projectType === PROJECT_TYPES.ID8
      ? {
          instructions: Yup.string().required('required'),
        }
      : {}),
  });
};

export const editProjectFileFormYupValidation = () => {
  return Yup.object().shape({
    file: Yup.mixed().required('required'),
  });
};

export const changeProjectPasswordFormYupValidation = () => {
  return Yup.object().shape({
    password: Yup.string()
      .required('required')
      .min(15, 'min15')
      .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/, 'passwordPattern'),
  });
};
